declare namespace $ {

	type $shm_hitalama_components_settings__definition_shm_hitalama_components_parameters_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_parameters['definition'] >
		,
		ReturnType< $shm_hitalama_components_settings['definition'] >
	>
	type $shm_hitalama_components_settings__saving_shm_hitalama_components_parameters_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_parameters['saving'] >
		,
		ReturnType< $shm_hitalama_components_settings['saving'] >
	>
	type $shm_hitalama_components_settings__save_error_shm_hitalama_components_parameters_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_parameters['save_error'] >
		,
		ReturnType< $shm_hitalama_components_settings['save_error'] >
	>
	type $shm_hitalama_components_settings__removed_shm_hitalama_components_parameters_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_parameters['removed'] >
		,
		ReturnType< $shm_hitalama_components_settings['removed'] >
	>
	export class $shm_hitalama_components_parameters extends $mol_page {
		Settings( ): $shm_hitalama_components_settings
		definition( ): $shm_hitalama_map_widget_entity_custom
		saving( ): boolean
		save_error( ): string
		removed( next?: any ): any
		title( ): string
		minimal_width( ): number
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=parameters.view.tree.d.ts.map